import type { BookingStatus } from "@ai-admin/shared";
import type { Tone } from "../../ui/index.js";

export const statusTone: Record<BookingStatus, Tone> = {
  held: "brand",
  pending: "amber",
  confirmed: "green",
  completed: "slate",
  no_show: "red",
  cancelled: "slate",
  rejected: "slate",
  expired: "slate",
  released: "slate",
};

/** Запись больше не занимает время: показываем бледной. */
export const isDead = (s: BookingStatus): boolean => s === "cancelled" || s === "rejected" || s === "expired" || s === "released";

/** Ссылка на переписку в Instagram по @нику (открывает Direct в приложении). */
export const instagramLink = (handle: string): string => `https://ig.me/m/${encodeURIComponent(handle.replace(/^@/, ""))}`;
